// prettier-ignore
export const ActionTypes = {
  SET_REPEAT_SERIAL_NUMBERS: 'harami/templates/SET_REPEAT_SERIAL_NUMBERS',
  UPDATE_REPEAT_SERIAL_NUMBER: 'harami/templates/UPDATE_REPEAT_SERIAL_NUMBER',
} as const satisfies { [k: string]: string}
